import firebase from './index';
import 'firebase/compat/analytics';

const analytics = firebase.analytics();

export default analytics;
